import { z } from "zod";
import { PayStandAddressSchema } from "./pay-stand-address";

export const PayStandCardSchema = z.object({
  id: z.string(),
  object: z.string(),
  nameOnCard: z.string(),
  brand: z.string(),
  last4: z.string(),
  expirationMonth: z.string(),
  expirationYear: z.string(),
  fingerprint: z.string(),
  payerId: z.string(),
  billingAddress: PayStandAddressSchema,
  status: z.string(),
  funding: z.string(),
  created: z.string(),
  lastUpdated: z.string(),
});

export type PayStandCardType = z.infer<typeof PayStandCardSchema>;
